import { useMemo } from 'react';
import { Button } from '@alf/uikit';
import { useGeneralRoutes } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';
import { useHistory } from '@namespace/router';
import { BONUS_SOURCE_TYPE } from '../../../../constants';

export const BonusDetailsButton = ({
  bonusSourceType,
  bonusId,
  isShowTakePart
}) => {
  const { push } = useHistory();
  const {
    fundsBonusList,
    fundsBonusDetails,
    casinoBonusList,
    casinoBonusDetails
  } = useGeneralRoutes();
  const { t } = useI18n();

  const bonusLink = useMemo(() => {
    if (bonusSourceType?.startsWith('bs')) {
      return `${fundsBonusDetails}/bs${bonusId}`;
    }

    return `${
      bonusSourceType === BONUS_SOURCE_TYPE.CRM_FREE_SPINS
        ? casinoBonusDetails
        : fundsBonusDetails
    }/${bonusId}`;
  }, [bonusId, bonusSourceType, casinoBonusDetails, fundsBonusDetails]);

  const bonusLinkWithoutId = `${
    bonusSourceType === BONUS_SOURCE_TYPE.CRM_FREE_SPINS
      ? casinoBonusList
      : fundsBonusList
  }`;

  return (
    <Button
      onClick={() => push(!isShowTakePart ? bonusLink : bonusLinkWithoutId)}
      intent="secondary"
      size="m"
      actionType="color1"
      fullWidth={true}
      data-role="bonus-item-gotobonus-btn"
    >
      {t('web.bonuses.button.gotobonus')}
    </Button>
  );
};
